export class Neighbourhood {
  public id: string;
  public name: string;

  constructor(data: Partial<Neighbourhood> = {}) {
    this.id = data?.id ?? '';
    this.name = data?.name ?? '';
  }

  public static createFromApi(data: Partial<Neighbourhood> = {}): Neighbourhood {
    return new Neighbourhood(data);
  }
}
